import { useState, useEffect } from 'react';
import { getValidation } from '../Api/content';
import { useLocale } from '../i18n/localeContext';
import WebApi from '../Api/WebApi';

export const useValidation = () => {
  const [validation, setValidation] = useState(null);
  const [loading, setLoading] = useState(true);
  const { locale } = useLocale();

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    
    const getValidationsFromBackend = async (locale) => {
      try {
        const response = await WebApi.get(`/Validation?locale=${locale}`);
        if (!cancel && response?.data) {
          setValidation(response.data);
          setLoading(false);
        }
      } catch (error) {
        if (!cancel) {
          // Usar validaciones por defecto si todo falla
          setValidation(getDefaultValidations(locale));
          setLoading(false);
        }
      }
    };
    
    // Intentar obtener desde Strapi primero
    getValidation(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel && data) {
          setValidation(data);
          setLoading(false);
        } else {
          // Si no hay datos de Strapi, intentar desde el backend
          getValidationsFromBackend(locale);
        }
      })
      .catch(() => {
        // Si falla Strapi, intentar desde el backend
        if (!cancel) {
          getValidationsFromBackend(locale);
        }
      });
    
    return () => { cancel = true };
  }, [locale]);

  const getDefaultValidations = (locale = 'es') => {
    const validations = {
      es: {
        required_field: "Campo requerido",
        mandatory_field: "Campo obligatorio",
        invalid_email: "Escriba un correo valido",
        duplicate_email: "El correo: {email} de tipo {tipoCorreo} ya existe",
        password_mismatch: "Las contraseñas no coinciden",
        password_missing: "Se deben ingresar ambas contraseñas (la actual y la nueva)",
        legal_dni_empty: "Encargado Legal Dni no puede estar vacio",
        legal_name_empty: "Encargado Legal nombre no puede estar vacio",
        legal_phone_empty: "Encargado Legal telefono no puede estar vacio",
        studies_not_specified: "Debe especificar sus estudios.",
        student_studies_empty: "El estudiante debe ingresar sus estudios",
        year_not_specified: "Debe especificar el año",
        period_not_specified: "Debe especificar el período de la solicitud",
        session_not_specified: "Debe especificar la sesión de la solicitud",
        curriculum_not_specified: "Debe especificar el curriculum de la solicitud",
        curriculum_session_not_specified: "Debe especificar la sesión del curriculum de la solicitud",
        scholarship_or_level_required: "Debe elegir una beca o un nivel para continuar.",
        document_not_selected: "Debe seleccionar algún documento",
        student_exists: "Estudiante ya existe",
        student_not_found: "Estudiante no encontrado",
        request_not_found: "Solicitud no encontrada",
        confirm_reset_field: "¿Seguro que desea restablecer el valor del campo {nombre}?",
        field_updated: "Campo actualizado",
        record_modified: "Se ha modificado el registro",
        record_created: "Se ha creado el registro",
        documents_recommendation: "Antes de iniciar, le recomendamos tener listos los siguientes documentos en formato digital (.jpg, .png, .pdf o .docx), ya que serán requeridos durante el proceso:",
        document_id_requirement: "Documento de identificación (Cédula, DIMEX o Pasaporte). Debe ser claro, legible y por ambas caras.",
        is_mandatory: "¿Es obligatorio?",
        documents_required: "Documentos requeridos"
      }
    };
    
    return validations[locale] || validations['es'];
  };

  return { validation, loading };
};
